/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Rate_Billing_DayInputs */

const en_admin_resource_form_rate_billing_day = /** @type {(inputs: Admin_Resource_Form_Rate_Billing_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`per day`)
};

const de_admin_resource_form_rate_billing_day = /** @type {(inputs: Admin_Resource_Form_Rate_Billing_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pro Tag`)
};

const es_admin_resource_form_rate_billing_day = /** @type {(inputs: Admin_Resource_Form_Rate_Billing_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`por día`)
};

const fr_admin_resource_form_rate_billing_day = /** @type {(inputs: Admin_Resource_Form_Rate_Billing_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`par jour`)
};

const nl_admin_resource_form_rate_billing_day = /** @type {(inputs: Admin_Resource_Form_Rate_Billing_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`per dag`)
};

/** @type {(inputs: Admin_Resource_Form_Rate_Billing_DayInputs) => LocalizedString} */
const it_admin_resource_form_rate_billing_day = en_admin_resource_form_rate_billing_day;

/** @type {(inputs: Admin_Resource_Form_Rate_Billing_DayInputs) => LocalizedString} */
const pt_br2_admin_resource_form_rate_billing_day = en_admin_resource_form_rate_billing_day;

/** @type {(inputs: Admin_Resource_Form_Rate_Billing_DayInputs) => LocalizedString} */
const pl_admin_resource_form_rate_billing_day = en_admin_resource_form_rate_billing_day;

/** @type {(inputs: Admin_Resource_Form_Rate_Billing_DayInputs) => LocalizedString} */
const hu_admin_resource_form_rate_billing_day = en_admin_resource_form_rate_billing_day;

/** @type {(inputs: Admin_Resource_Form_Rate_Billing_DayInputs) => LocalizedString} */
const ro_admin_resource_form_rate_billing_day = en_admin_resource_form_rate_billing_day;

/**
* | output |
* | --- |
* | "per day" |
*
* @param {Admin_Resource_Form_Rate_Billing_DayInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_rate_billing_day = /** @type {((inputs?: Admin_Resource_Form_Rate_Billing_DayInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Rate_Billing_DayInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_rate_billing_day(inputs)
	if (locale === "de") return de_admin_resource_form_rate_billing_day(inputs)
	if (locale === "es") return es_admin_resource_form_rate_billing_day(inputs)
	if (locale === "fr") return fr_admin_resource_form_rate_billing_day(inputs)
	if (locale === "nl") return nl_admin_resource_form_rate_billing_day(inputs)
	if (locale === "it") return it_admin_resource_form_rate_billing_day(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_rate_billing_day(inputs)
	if (locale === "pl") return pl_admin_resource_form_rate_billing_day(inputs)
	if (locale === "hu") return hu_admin_resource_form_rate_billing_day(inputs)
	return ro_admin_resource_form_rate_billing_day(inputs)
});
export { admin_resource_form_rate_billing_day as "admin.resource_form.rate_billing_day" }